// const BASE_URL = "http://localhost:5035/scanner-api/";
const BASE_URL = "https://scanning.passionit.com/scanner-api/";


//////////////pdf upload//////
export const UPLOAD_PDF_API = `${BASE_URL}upload-pdf`;
export const POST_QRCODE = `${BASE_URL}qrcodeinfo`;
export const GET_QRINFO = `${BASE_URL}qrcodeinfo/bylink`;